import axios from "axios";
import { BASE_API_URL } from "./const";

// Создаем экземпляр axios
const api = axios.create({
  baseURL: BASE_API_URL, // Базовый URL API
});

// Интерцептор для добавления токена в каждый запрос
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("lionsarena.Token"); // Получаем токен из localStorage
    if (token) {
      config.headers["http-x-token"] = token; // Добавляем токен в заголовок
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
